<template>
  <div v-if="!props.isAddCart"
       class="price-breakdown-content">
    <div :class="['total-price', props.isDesign ? 'total-bg' : 'total-border-bottom']">
      <span :class="['total-price-label', props.isDesign ? 'text-marL' : '']">
        {{ $t('CustomSpus.PriceBreakdown.totalPrice') }}
      </span>
      <div class="price-right">
        <span class="price">
          {{ calcPrice.calcTotalPrice(price_details, props.quantity || 1, true) }}
        </span>
        <span v-if="!props.customPriceDetail?.sku_price"
              class="start-price">{{ $t('CustomSpus.PriceBreakdown.startPrice') }}
        </span>
      </div>
      <img v-if="props.isDesign"
           src="../../icon/total-price.png">
    </div>
    <div class="other-price">
      <span :class="['price-label', props.isDesign ? '' : 'design-text']">
        {{ $t('CustomSpus.PriceBreakdown.clothingPrice') }}
      </span>
      <span v-show="baseDiscount.clothing && baseDiscount.clothing.value != 100"
            class="discount">
        {{ baseDiscount.clothing.name }}
      </span>
      <div class="price-right">
        <span :class="baseDiscount.clothing && baseDiscount.clothing.value != 100 ? 'discount-price' : 'price'">
          {{ exactDecimal(DetermineSourcePrice()) }}</span>
        <span v-show="baseDiscount.clothing && baseDiscount.clothing.value != 100"
              class="price">
          {{ exactDecimal(calculateDiscount('clothing',
            DetermineSourcePrice()!)) }}
        </span>
        <span v-if="!props.customPriceDetail?.sku_price"
              class="start-price">{{ $t('CustomSpus.PriceBreakdown.startPrice') }}</span>
      </div>
    </div>
    <div v-show="props.isCustom && props.customPriceDetail?.custom_price"
         class="other-price">
      <span :class="['price-label', props.isDesign ? '' : 'design-text']">{{
        $t('CustomSpus.PriceBreakdown.printingTotalPrice') }}
      </span>
      <span v-show="baseDiscount.design && baseDiscount.design.value != 100"
            class="discount">{{ baseDiscount.design.name }}
      </span>
      <div class="price-right">
        <span :class="baseDiscount.design && baseDiscount.design.value != 100 ? 'discount-price' : 'price'">{{
          customAreaPrice.originalPrice }}</span>
        <span v-show="baseDiscount.design && baseDiscount.design.value != 100"
              class="price">
          {{ customAreaPrice.customAreaPrice }}</span>
      </div>
      <ul class="custom-details">
        <li v-for="item of props.customPriceDetail.custom_price"
            class="custom-details-area">
          <p v-if="!item.discount_amount_scale && $props.customPriceDetail.discount_amount_scale">{{ item.name[0] }}{{
            props.customPriceDetail.customized_areas_scale_title ? ' ( ' +
            props.customPriceDetail.customized_areas_scale_title + ' ) ' : ''
          }}: {{
  exactDecimal(priceTimes((item.technology?.price || item.price).toString(), priceScale())) }} {{
    $t('CustomSpus.PriceBreakdown.startPrice') }} (
            {{ (item.technology?.name || $t('CustomSpus.PriceBreakdown.print')) }} )</p>
          <p v-else>
            {{ item.name[0] }}{{ item.customized_areas_scale_title ? ' ( ' + item.customized_areas_scale_title + ' ) ' :
              ''
            }}: {{
  exactDecimal(priceTimes((item.technology?.price || item.price).toString(), item.discount_amount_scale ||
    priceScale())) }} {{ $t('CustomSpus.PriceBreakdown.startPrice') }} ( {{ (item.technology?.name ||
      $t('CustomSpus.PriceBreakdown.print')) }} )
          </p>
          <p v-if="item.dss_image_price && item.dss_image_price != '0'">
            <span>{{ $t('CustomSpus.PriceBreakdown.designImage') }}：{{ item.dss_image_price }}</span>
            <a-tooltip>
              <template #title>{{ $t('CustomSpus.PriceBreakdown.designImageNoDiscount') }}</template>
              <question-circle-outlined class="icon-margin" />
            </a-tooltip>
          </p>
        </li>
      </ul>
    </div>
  </div>
  <div v-else
       class="price-breakdown-content-shopping">
    <p class="total-price">￥ {{ calcPrice.calcTotalPrice(price_details, props.quantity || 1, true) }}</p>
    <div class="price-list">
      <img src="../../icon/triangle.png"
           class="triangle">
      <div class="details">
        <div class="dot"></div>
        <p>
          {{ $t('CustomSpus.PriceBreakdown.clothingPrice') }}: <span class="price">
            {{ exactDecimal(calculateDiscount('clothing',
              DetermineSourcePrice()!)) }}
          </span>
          <span v-if="baseDiscount.clothing.name != $t('CustomSpus.PriceBreakdown.basePrice')"
                class="original-price">{{ DetermineSourcePrice() }}</span>
          <span v-if="baseDiscount.clothing.name != $t('CustomSpus.PriceBreakdown.basePrice')"
                class="discount-number">{{ baseDiscount.clothing.name }}</span>
        </p>
      </div>
      <div v-show="props.isCustom && props.customPriceDetail?.custom_price"
           class="details">
        <div class="dot"></div>
        <p>{{ $t('CustomSpus.PriceBreakdown.printingTotalPrice') }}:
          <span class="price">
            {{ customAreaPrice.customAreaPrice }}</span>
          <span v-if="baseDiscount.clothing.name != $t('CustomSpus.PriceBreakdown.basePrice')"
                class="original-price">{{ customAreaPrice.originalPrice }}</span>
          <span v-if="baseDiscount.clothing.name != $t('CustomSpus.PriceBreakdown.basePrice')"
                class="discount-number">{{ baseDiscount.clothing.name }}</span>
        </p>
      </div>
      <ul class="custom-details">
        <li v-for="(item, index) of props.customPriceDetail.custom_price"
            :key="index"
            class="custom-details-area">
          <p v-if="!item.discount_amount_scale && $props.customPriceDetail.discount_amount_scale">{{ item.name[0] }}{{
            props.customPriceDetail.customized_areas_scale_title ? ' ( ' +
            props.customPriceDetail.customized_areas_scale_title + ' ) ' : ''
          }}: {{
  exactDecimal(priceTimes((item.technology?.price || item.price).toString(), priceScale())) }} (
            {{ (item.technology?.name || $t('CustomSpus.PriceBreakdown.print')) }} )</p>
          <p v-else>
            {{ item.name[0] }}{{ item.customized_areas_scale_title ? ' ( ' + item.customized_areas_scale_title + ' ) ' :
              ''
            }}: {{
  exactDecimal(priceTimes((item.technology?.price || item.price).toString(), item.discount_amount_scale || 1))
}} ( {{ (item.technology?.name || $t('CustomSpus.PriceBreakdown.print')) }} )
          </p>
          <p v-if="item.dss_image_price && item.dss_image_price != '0'">
            <span>{{ $t('CustomSpus.PriceBreakdown.designImage') }}：{{ item.dss_image_price }}</span>
            <a-tooltip>
              <template #title>{{ $t('CustomSpus.PriceBreakdown.designImageNoDiscount') }}</template>
              <question-circle-outlined class="icon-margin" />
            </a-tooltip>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { container } from 'tsyringe'
import { numToDiscount } from '@/utils'
import type { AccountInfoOption } from '../../index'
import type { AccountInfoService } from '../../../account-info/index'
import type { Plugin } from '@/plugins'
import { PLUGIN_ACCOUNT_INFO } from '@/plugins/builtin/BuiltinPluginSymbol'
import BigNumber from "bignumber.js"
import { DefaultCalcPriceHelper } from "@flashbase/util-coupon"

const calcPrice = new DefaultCalcPriceHelper()

export type Technology = {
  id?: number
  name: string
  price: number
}

export interface CustomPrice {
  id: number
  name: string
  price: string
  customized_areas_scale: string
  customized_areas_scale_title: string
  discount_amount_scale: string
  technology: Technology
  dss_image_price: string
}

export interface CustomPriceDetail {
  custom_price: Array<CustomPrice> | []
  discount_amount_scale?: string
  customized_areas_scale_title?: string
  sku_price?: number | null
  spu_price: number
  spu_discount: {
    express: {
      value: number,
      name: string
    },
    clothing: {
      value: number,
      name: string
    },
    design: {
      value: number,
      name: string
    }
  } | any
}

const props = defineProps<{
  customPriceDetail: CustomPriceDetail
  isOrder?: boolean
  isCustom: boolean
  isDesign?: boolean
  isAddCart?: boolean
  quantity?: number
}>()
const accountInfoPlugin = container.resolve<Plugin<AccountInfoOption, AccountInfoService>>(PLUGIN_ACCOUNT_INFO)
let baseDiscount = accountInfoPlugin.options.baseDiscount.value
const calculateDiscount = (type: string, price: string) => {
  const discount = baseDiscount[type].value
  return new BigNumber(price).times(discount || 100).div(100).toFixed(2)
}
const customAreaPrice = ref<any>({
  customAreaPrice: 0,
  originalPrice: 0
})

const priceTimes = (price: string | number, discount: string | number) => {
  return new BigNumber(price).times(new BigNumber(discount))
}

watch(() => props.customPriceDetail.custom_price, (newV) => {
  customAreaPrice.value = {
    customAreaPrice: 0,
    originalPrice: 0
  }
  if (!props.customPriceDetail.spu_discount)
    // eslint-disable-next-line vue/no-mutating-props
    props.customPriceDetail.spu_discount = baseDiscount
  if (props.customPriceDetail && newV) {
    customAreaPrice.value.customAreaPrice = calcPrice.calcCustomPrice(props.customPriceDetail, true).customAreaPrice
    customAreaPrice.value.originalPrice = calcPrice.calcCustomPrice(props.customPriceDetail, true).originalPrice
  }
}, {
  deep: true,
  immediate: true
})
const price_details: any = computed(() => {
  const data = JSON.parse(JSON.stringify(props.customPriceDetail))
  if (!props.customPriceDetail.spu_discount) {
    data.spu_discount = baseDiscount
  }
  return data
})
watch(() => props.isOrder, () => {
  if (props.isOrder) {
    if (props.customPriceDetail.spu_discount.clothing) {
      baseDiscount = props.customPriceDetail.spu_discount
    } else {
      const tempDiscount = props.customPriceDetail.spu_discount || 100
      baseDiscount.clothing = {
        value: tempDiscount,
        name: numToDiscount(tempDiscount)
      }
      baseDiscount.design = {
        value: 100,
        name: numToDiscount(100)
      }
      baseDiscount.express = {
        value: 100,
        name: numToDiscount(100)
      }
    }
  }
}, {
  immediate: true
})

const exactDecimal = (value: any) => {
  return new BigNumber(value).toFixed(2)
}

const DetermineSourcePrice = () => {
  return !Number(props.customPriceDetail?.sku_price) ? props.customPriceDetail?.spu_price! : props.customPriceDetail?.sku_price
}


const priceScale = () => {
  return props.customPriceDetail.discount_amount_scale ? props.customPriceDetail.discount_amount_scale : 1
}

</script>
<style scoped lang="less">
.price-breakdown-content-shopping {
  p {
    margin: 0;
  }

  .total-price {
    font-size: 24px;
    font-weight: bold;
    color: #DE4A09;
  }

  .price-list {
    margin-top: 10px;
    padding-top: 15px;
    padding-left: 20px;
    width: 400px;
    position: relative;
    background-color: #e7e7e76b;

    .triangle {
      position: absolute;
      top: -8px;
      left: 50px;
    }
  }

  .details {
    width: 240px;
    display: flex;
    margin-bottom: 10px;

    .dot {
      width: 6px;
      height: 6px;
      background: black;
      border-radius: 6px;
      margin-top: 8px;
      margin-right: 5px;
    }

    p {
      font-size: 14px;
      font-weight: 400;
    }

    .original-price {
      text-decoration: line-through;
      color: #999999;
    }

    .discount-number {
      color: #de4a09;
      background: #fae4da;
      padding: 0 4px;
    }

    .original-price,
    .discount-number {
      font-family: "Microsoft YaHei";
      margin-left: 8px;
    }
  }

  .custom-details {
    padding: 0 15px;
    display: flex;
    flex-flow: wrap;

    .custom-details-area {
      width: 100%;
      min-height: 30px;
      line-height: 30px;

      p {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }

      .icon-margin {
        margin-left: 5px;
      }
    }
  }
}

.price-breakdown-content {
  p {
    margin: 0;
  }

  .custom-details {
    margin-top: 10px;
    width: 240px;
    background: #F6F6F6;
    padding: 5px 15px 5px 15px;
    display: flex;
    flex-flow: wrap;

    .custom-details-area {
      width: 100%;
      min-height: 30px;
      line-height: 30px;

      p {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }

      .icon-margin {
        margin-left: 5px;
      }
    }
  }

  .other-price {
    width: 240px;
    margin-top: 8px;

    .price-label {
      font-size: 14px;
      font-weight: 400;
    }

    .design-text {
      color: #999999;
    }
  }

  .total-border-bottom {
    border-bottom: 1px solid #f1f1f1;
  }

  .total-bg {
    background: url(../../icon/total-price-bg.png);
  }


  .total-price {
    width: 245px;
    height: 40px;
    position: relative;

    .total-price-label {
      font-size: 14px;
      font-weight: bold;
      color: #111111;
      padding-top: 10px;
      line-height: 40px;
    }

    .text-marL {
      margin-left: 22px;
    }

    img {
      position: absolute;
      left: -12px;
      top: 10px;
      width: 24px;
      height: 20px;
    }

    .price {
      font-size: 20px;
      font-weight: bold;
      color: #DE4A09;
    }
  }

  .price-right {
    float: right;
  }

  .price {
    margin-left: 5px;
    font-size: 16px;
    font-weight: bold;
    color: #111111;
  }

  .discount-price {
    margin-left: 5px;
    color: #b8b8b8;
    text-decoration: line-through;
  }

  .discount {
    background-color: #de490937;
    margin-left: 5px;
    padding: 0 2px;
    font-size: 14px;
    font-weight: 400;
    color: #DE4A09;
  }

  .start-price {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    // transform: scale(0.7);
    // display: inline-block;
    // transform-origin: 0 1;
  }
}
</style>
